import { insertTrackEvent } from './common.js';

const notificationClick = label => {
	insertTrackEvent({
		category: 'Sidebar',
		action: 'Click - Notification Item',
		label
	});
};

const notificationMarkAllRead = numberUnreadNotifications => {
	insertTrackEvent({
		category: 'Sidebar',
		action: 'Click - Mark all as read - Notifications',
		label: numberUnreadNotifications
	});
};

const notificationClickCategory = newCategory => {
	insertTrackEvent({
		category: 'Notifications',
		action: 'Category click',
		label: newCategory
	});
};

const notificationReceived = label => {
	insertTrackEvent({
		category: 'Sidebar',
		action: 'Notification received',
		label
	});
};

const notificationBlueBarShown = id => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Blue bar displayed',
		label: id
	});
};

const notificationBluebarClicked = (outsideCTA, id) => {
	insertTrackEvent({
		category: 'Notification',
		action: outsideCTA ? 'Blue bar clicked: Outside CTA' : 'Blue bar clicked',
		label: id
	});
};

const notificationBluebarClosed = id => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Blue bar closed',
		label: id
	});
};

// const notificationPopupDisplayed = label => {
// 	insertTrackEvent({
// 		category: 'Notification',
// 		action: 'Pop-up displayed',
// 		label
// 	});
// };

const notificationPopupXClicked = label => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Pop-up X clicked',
		label
	});
};

const notificationPopupCTAClicked = label => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Pop-up CTA clicked',
		label
	});
};

const notificationDetailPageOpened = label => {
	insertTrackEvent({
		category: 'Sidebar',
		action: 'Detail page',
		label
	});
};

const notificationClickToMyNotificationsDetailPageCTA = label => {
	insertTrackEvent({
		category: 'Sidebar',
		action: 'Click - Notification CTA',
		label
	});
};

const notificationCarouselShown = noCarouselItems => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Pop-up carousel shown',
		label: noCarouselItems
	});
};

const notificationCarouselClosed = label => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Pop-up carousel closed',
		label
	});
};

const notificationCarouselTnCClicked = label => {
	insertTrackEvent({
		category: 'Notification',
		action: 'Pop-up T&C clicked',
		label
	});
};

export {
	notificationClick,
	notificationMarkAllRead,
	notificationClickCategory,
	notificationReceived,
	notificationBlueBarShown,
	notificationBluebarClicked,
	notificationBluebarClosed,
	// notificationPopupDisplayed,
	notificationPopupXClicked,
	notificationPopupCTAClicked,
	notificationDetailPageOpened,
	notificationClickToMyNotificationsDetailPageCTA,
	notificationCarouselShown,
	notificationCarouselClosed,
	notificationCarouselTnCClicked
};
